import UserService from "../services/user.service"
import EventBus from "./EventBus";

const check = (func) => {
    UserService.getUserBoard().then(
        (response) => {
          func(response.data);
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
    
            func(_content);
    
          if (error.response && error.response.status === 403) {  //401, ให้ logout เมื่อเจอ 403
            EventBus.dispatch("logout");
          }
        }
      );
}

const SessionService = {
    check
  };

export default SessionService;
